import * as Yup from 'yup';

export const externalReportFormModel = {
  formId: 'externalReportConfig',
  formField: {
    site: {
      name: 'site',
      label: 'Select Site',
      type: 'select',
      data: [{ id: 'all', name: 'All' }]
    },
    date: {
      name: 'date',
      label: 'Date',
      type: 'date',
      errorMsg: 'Date is required!'
    }
  }
};

const {
  formField: {
    site,
    date
  }
} = externalReportFormModel;

export const externalReportFormInitialValues = {
  [site.name]: 'all',
  [date.name]: ''
};

export const externalReportValidationSchema = Yup.object().shape({
  [date.name]: Yup.date().nullable().required(date.errorMsg)
});
